export default function StatsImpact() {
  const stats = [
    {
      number: '200+',
      label: 'Başarılı Proje',
      icon: 'ri-checkbox-circle-line'
    },
    {
      number: '15+',
      label: 'Farklı Sektör',
      icon: 'ri-building-line'
    },
    {
      number: '%100',
      label: 'Müşteri Memnuniyeti',
      icon: 'ri-star-fill'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#2D3436] to-[#1D2426] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border-2 border-[#C17F59] rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 border-2 border-[#C17F59] rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#C17F59] rounded-full blur-3xl opacity-20"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4 tracking-tight">
            Rakamlarla KGM Danışmanlık
          </h2>
          <p className="text-lg text-gray-300">
            Güven ve başarı odaklı çalışmalarımızın sonuçları
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-10 text-center hover:bg-white/10 hover:border-[#C17F59]/50 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 rounded-xl bg-[#C17F59]/20 flex items-center justify-center mx-auto mb-6 group-hover:bg-[#C17F59] transition-all duration-300">
                <i className={`${stat.icon} text-3xl text-[#C17F59] group-hover:text-white transition-all duration-300`}></i>
              </div>
              <div className="text-6xl font-bold text-white mb-3 tracking-tight">
                {stat.number}
              </div>
              <div className="text-base text-gray-300 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
